/** Width of the stage. */
export const STAGE_W = 640;
/** Height of the stage. */
export const STAGE_H = 480;
/**
 * Width of the stage when printing. Fixed rather than measured: the container
 * still reports the on-screen layout while the print event runs, and the page
 * orientation is not observable from script.
 */
export const PRINT_STAGE_W = 600;

/** Padding left of stage relative to chart left */
export const PAD_L = 160;
/** Padding right of stage relative to chart right */
export const PAD_R = 80;
/** Padding top of stage relative to chart top */
export const PAD_T = 60;
/** Padding bottom of stage relative to chart bottom */
export const PAD_B = 20;

export const DOT_OPACITY = 0.8;

/** Colors for the dots - TBD. */
export const DOT_FILL = [
    '#4e79a7',
    '#f28e2b',
    '#e15759',
    '#76b7b2',
    '#59a14f',
    '#edc948',
    '#b07aa1',
    '#ff9da7',
    '#9c755f',
    '#bab0ac',
    '#17becf',
    '#aec7e8',
    '#ffbb78',
    '#98df8a',
    '#ff9896',
    '#c5b0d5',
    '#c49c94',
    '#f7b6d2',
    '#dbdb8d',
    '#9edae5',
];
